import React from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {IntlProvider} from 'react-intl';
import messages from '../../res/translations';
import AuthenticatedRoute from './auth/AuthenticatedRoute';
import Layout from './Layout';
import Login from './auth/Login';

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const navigatorLanguage = (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage ||
    'en';
const browserLanguage = navigatorLanguage.toLowerCase().split(/[_-]+/)[0];
// const browserLanguage = 'en';

const Main = ({authLoading, language}) => {
    if (authLoading) {
        return null;
    }
    return (
        <IntlProvider key={language} locale={language} messages={messages[language]}>
            <Switch>
                <Route path="/login" component={Login} />
                <AuthenticatedRoute component={Layout} />
            </Switch>
        </IntlProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        authLoading: state.auth.firstLoading,
        language: state.settings.language || browserLanguage,
    };
};

export default connect(mapStateToProps)(Main);
